import { motion } from "framer-motion";
import { MapPin, Instagram, ExternalLink } from "lucide-react";

const fadeUp = {
  hidden: { opacity: 0, y: 30 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.1, duration: 0.6 },
  }),
};

export default function ContactPage() {
  return (
    <div className="pt-28 lg:pt-44" data-testid="contact-page">
      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid lg:grid-cols-2 gap-16">
            <div>
              <p className="font-accent text-2xl text-sunset mb-2">say hello</p>
              <h1 className="font-display text-4xl sm:text-5xl tracking-tight mb-6">
                Get in Touch
              </h1>
              <p className="text-charcoal/60 leading-relaxed mb-12">
                Whether you want to book a session, ask a question, or just say hi — I'd love to
                hear from you.
              </p>

              <div className="space-y-6 mb-12">
                <div className="flex items-center gap-4">
                  <div className="w-12 h-12 rounded-2xl bg-peachlight flex items-center justify-center">
                    <MapPin className="text-sage" size={20} />
                  </div>
                  <div>
                    <h3 className="font-medium text-sm">Location</h3>
                    <p className="text-charcoal/60 text-sm">Bude, Cornwall, UK</p>
                  </div>
                </div>
                <a
                  href="https://www.instagram.com/justjjax"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-4 group"
                  data-testid="contact-instagram"
                >
                  <div className="w-12 h-12 rounded-2xl bg-peachlight flex items-center justify-center">
                    <Instagram className="text-sage" size={20} />
                  </div>
                  <div>
                    <h3 className="font-medium text-sm group-hover:text-sage transition-colors">
                      Instagram
                    </h3>
                    <p className="text-charcoal/60 text-sm">@justjjax</p>
                  </div>
                </a>
                <a
                  href="https://tinyurl.com/2nxodcgu"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-4 group"
                  data-testid="contact-booking"
                >
                  <div className="w-12 h-12 rounded-2xl bg-peachlight flex items-center justify-center">
                    <ExternalLink className="text-sage" size={20} />
                  </div>
                  <div>
                    <h3 className="font-medium text-sm group-hover:text-sage transition-colors">
                      Book Online
                    </h3>
                    <p className="text-charcoal/60 text-sm">Book via Slick</p>
                  </div>
                </a>
              </div>
            </div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 }}
            >
              <div className="bg-white rounded-3xl p-8 md:p-10 border border-ocean/5">
                <h3 className="font-display text-lg mb-4">Follow the Journey</h3>
                <div className="grid grid-cols-2 gap-4">
                  {[
                    {
                      name: "Instagram",
                      url: "https://www.instagram.com/justjjax",
                      handle: "@justjjax",
                    },
                    {
                      name: "TikTok",
                      url: "https://tiktok.com/@justjjax",
                      handle: "@justjjax",
                    },
                    {
                      name: "YouTube",
                      url: "https://youtube.com/@justjjax",
                      handle: "@justjjax",
                    },
                    {
                      name: "Facebook",
                      url: "https://facebook.com/justjjax",
                      handle: "Justjjax",
                    },
                  ].map((social) => (
                    <a
                      key={social.name}
                      href={social.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-4 rounded-2xl bg-sand/50 hover:bg-sage/10 transition-colors"
                      data-testid={`contact-social-${social.name.toLowerCase()}`}
                    >
                      <p className="font-medium text-sm">{social.name}</p>
                      <p className="text-charcoal/40 text-xs">{social.handle}</p>
                    </a>
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
}
